import { useMutation } from "@apollo/client/react"; import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { CustomButton } from '../../../../../components/customButton/CustomButton';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { Box } from '@mui/material';
import { CustomDialog } from '../../../../../components/customDialog/CustomDialog';
import DataGridGenerico from '../../../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../../../components/dataGrid/columnHelpers';
import { PopoverModal } from '../../../../../components/popoverModal/PopoverModal';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import moment from 'moment';
import CustomButtonAdjuntar from '../../../../../components/customButton/CustomButtonAdjuntar';
import { AttachedFile } from '../../../../../components/attachedFile/AttachedFile';
import BORRAR_DOCUMENTOS_RECLAMO from '../../../../../data/graphQL/mutations/Reclamo/BorrarDocumentoReclamo';

import toast from 'react-hot-toast';

const AdjuntosModal = ({
  idGestionReclamo,
  idUsuarioLoggeado,
  nombreUsuarioLoggeado,
  onSaveAdjuntos,
  initialAdjuntos,
  submitLoading,
  disabled,
  queryAdjuntos,
  getAdjuntosLoading
}) => {

  const attachColumns = [
    {
      field: 'action',
      flex: 1,
      headerName: '',
      align: 'center',
      renderCell: ({ row }) => {
        const rowIndex = row.id - 1;
        const showDeleteButton = row.idUsuario === idUsuarioLoggeado && !disabled;
        return (
          <PopoverModal key={`row-titulo-${row.titulo}-row-id${row.id}`}>
            <div className='popover-modal-content'>
              <AttachedFile
                file={{
                  archivo: row.archivo,
                  contentType: row.contentType,
                  extension: row.extension,
                  titulo: row.titulo
                }}
                type={!!row.idArchivo ? 'blob' : 'base64'}
                title='Ver'
                popoverMenuOption={true} />

              {showDeleteButton && <div onClick={() => onDeleteRow(row, rowIndex)} aria-hidden='true' className='item-option clickable-option'>
                <DeleteOutlinedIcon className='edit-icon' />
                <span className='toggle-action'>Borrar</span>
              </div>}
            </div>
          </PopoverModal>);

      }
    },
    { field: 'idArchivo', headerName: '#', flex: 2 },
    { field: 'titulo', headerName: 'Archivo', flex: 5 },
    { field: 'idUsuario', headerName: 'ID Usuario', flex: 5 },
    { field: 'usuario', headerName: 'Usuario', flex: 5 },
    { field: 'fechaAlta', headerName: 'Fecha de alta', flex: 5, type: 'date' }];


  const [openModal, setOpenModal] = useState(false);
  const [adjuntos, setAdjuntos] = useState(initialAdjuntos || []);

  useEffect(() => {
    setAdjuntos(initialAdjuntos || []);
  }, [initialAdjuntos]);

  const [borrarDocumento, { loading: borrarDocumentoLoading }] = useMutation(BORRAR_DOCUMENTOS_RECLAMO, {
  });

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = useCallback(() => {
    setOpenModal(false);
    setAdjuntos(initialAdjuntos || []);
  }, [initialAdjuntos]);

  const onDeleteRow = (row, rowIndex) => {
    if (!!row.idArchivo) {
      borrarDocumento({
        variables: {
          idArchivo: row.idArchivo
        }
      }).then((res) => {
        if (res?.data?.borrarDocumentoReclamo?.success) {
          setAdjuntos((prev) => [...prev.filter((adjunto, adjuntoIndex) => row.idArchivo && row.idArchivo !== adjunto.idArchivo || rowIndex !== adjuntoIndex)]);
          queryAdjuntos({
            variables: {
              idGestionReclamo: idGestionReclamo
            }
          });
          toast.success('Adjunto eliminado.');
        }
      });
    } else

      setAdjuntos((prev) => [...prev.filter((adjunto, adjuntoIndex) => row.idArchivo && row.idArchivo !== adjunto.idArchivo || rowIndex !== adjuntoIndex)]);
  };

  const handleAddFile = useCallback((file) => {
    const newAdjunto = {
      idGestionReclamo,
      idUsuario: idUsuarioLoggeado,
      usuario: nombreUsuarioLoggeado,
      fechaAlta: moment().format('yyyy-MM-DD HH:mm:ss'),
      ...file
    };
    setAdjuntos((prev) => [...prev, newAdjunto]);
  }, []);

  const onSubmit = useCallback(() => {
    onSaveAdjuntos(adjuntos).then(() => {
      if (!!idGestionReclamo) {
        queryAdjuntos({
          variables: {
            idGestionReclamo: idGestionReclamo
          }
        });
      };
      handleCloseModal();
    });
  }, [adjuntos]);

  const attachConfigColumns = useMemo(() => generateColumnsDefaultConfiguration(attachColumns), []);

  return (
    <>
      <CustomButton
        label='Adjuntos'
        className='adjuntos-reclamo'
        disabled={false}
        onClick={handleOpenModal}
        endIcon={<AttachFileIcon />}
        variant='standar' />

      <CustomDialog
        open={openModal}
        title={<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          Archivos adjuntos
          {!disabled && <CustomButtonAdjuntar
            customButtonProps={{
              fullWidth: true,
              variant: 'outlined',
              component: 'label'
            }}
            onAddFile={handleAddFile} />
          }
        </Box>}
        acceptText='Agregar'
        onAccept={onSubmit}
        acceptDisabled={disabled}
        acceptLoading={submitLoading}
        cancelText='Cerrar'
        onCancel={handleCloseModal}
        fullWidth
        maxWidth='md'>

        <DataGridGenerico
          columns={attachConfigColumns}
          rows={adjuntos}
          totalCount={adjuntos.length}
          toolbar={false}
          hideFooterPagination={false}
          loading={getAdjuntosLoading} />

      </CustomDialog>
    </>);

};

export default AdjuntosModal;